/**
 * Compares two objects and returns if they are deeply equal.
 * @todo Make it more robust by handling edge cases like circular references,
 * functions, etc.
 */
export function deepEqual(a, b) {
    if (a === b) {
        return true;
    }
    if (typeof a !== "object" || a === null || typeof b !== "object" || b === null) {
        return false;
    }
    if (Array.isArray(a) && Array.isArray(b)) {
        if (a.length !== b.length) {
            return false;
        }
        for (let i = 0; i < a.length; i++) {
            if (!deepEqual(a[i], b[i])) {
                return false;
            }
        }
        return true;
    }
    const entriesA = Object.entries(a).filter(([, value]) => value !== undefined);
    const entriesB = Object.entries(b).filter(([, value]) => value !== undefined);
    const keysA = new Set(entriesA.map(([key]) => key));
    const keysB = new Set(entriesB.map(([key]) => key));
    if (keysA.symmetricDifference(keysB).size > 0) {
        return false;
    }
    for (const key of keysA) {
        if (!deepEqual(a[key], b[key])) {
            return false;
        }
    }
    return true;
}
//# sourceMappingURL=deep-equal.js.map